import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
// Components
import ServicesTable from "../Elements/ServicesTable";

export default function Services() {
  const navigate = useNavigate();
  const handleClick = (type) =>{
    if(type === "review")
      navigate('/RsopHome')
    else if(type === 'extensive')
      navigate('/')
  }
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Check Our Services</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull">
            <TableBox>
              <ServicesTable
                icon="review"
                price="$29,99/mo"
                title="REview SOP"
                text="A comprehensive review of your SOP to ensure it meets all necessary requirements.
                Includes detailed feedback and suggestions for improvement."
                offers={[
                  { name: "Product Offer", cheked: true },
                  { name: "Offer", cheked: true },
                  { name: "Product Offer #2", cheked: false },
                  { name: "Product", cheked: false },
                  { name: "Product Offer", cheked: false },
                ]}
                action={() => handleClick("review")}
              />
            </TableBox>
            <TableBox>
              <ServicesTable
                icon="monitor"
                price="$49,99/mo"
                title="Extensive SOP"
                text="A complete SOP writing service, from initial draft to final approval.
                Includes in-depth research and expert guidance throughout the process."
                offers={[
                  { name: "Product Offer", cheked: true },
                  { name: "Offer", cheked: true },
                  { name: "Product Offer #2", cheked: true },
                  { name: "Product", cheked: true },
                  { name: "Product Offer", cheked: false },
                ]}
                action={() => alert("Coming soon !!")}
              />
            </TableBox>
          </TablesWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 48%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto
  }
`;




